// Version : 0.0.1
// Author : SABARI
// LastEdit : SABARI
// Last ADD : Added the comments
// MODIFIED DATE : 27-09-2025

import { call, put, takeLatest, all } from 'redux-saga/effects';
import CloseLoanAdvanceTypes from './close-loan-advance.types';
import {
	getAllLoanAdvanceCollectedMembersListFailure,
	getAllLoanAdvanceCollectedMembersListSuccess,
	getAllLoanAdvanceCollectedMembersListResponseChanged,
	fetchParticularAccountNameInfoSuccess,
	fetchParticularAccountNameInfoFailure,
	fetchParticularAccountNameInfoStartResponseChanged,
	getAccountsBasedonTypeResponseChanged,
	getAccountsBasedonTypeFailure,
	getAccountsBasedonTypeSuccess,
	updateCloseLoanAdvanceWithRepaymentResponseChanged,
	updateCloseLoanAdvanceWithRepaymentFailure,
	updateCloseLoanAdvanceWithRepaymentSuccess,
	revertCloseLoanAdvanceWithRepaymentFailure,
	revertCloseLoanAdvanceWithRepaymentSuccess,
	revertCloseLoanAdvanceWithRepaymentResponseChanged,
} from './close-loan-advance.action';
import {
	fetchAccountsBasedonType,
	fetchAllLoanAdvanceCollectedMembersList,
	fetchParticularAccountName,
	revertCloseLoanAdvanceWithRepayment,
	updateCloseLoanAdvanceWithRepayment,
} from './close-loan-advance.service';
import { encryptData } from '../../_common/enode-decode';

// import AlertManager from '../../../utils/alertManager';
/***************** GET ALL LOAN ADVANCE COLLECTED MEMBER LIST ****************** */
export function* getAllLoanAdvanceCollectedMembersListData({ payload }: any) {
	try {
		const { companyID, databaseName, branchID, centerID, groupID } = payload;
		const key = 'GetAllLoanAdvanceCollectedMemberkey';
		const jsonData = {
			BranchID: branchID,
			CenterID: centerID,
			CompanyID: companyID,
			DatabaseName: databaseName,
			GroupID: groupID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const response = yield call(fetchAllLoanAdvanceCollectedMembersList, encodeData);
		if (response.data.statusCode === '100') {
			yield put(getAllLoanAdvanceCollectedMembersListFailure(response.data));
		} else {
			yield put(getAllLoanAdvanceCollectedMembersListSuccess(response.data));
		}
	} catch (error) {
		yield put(getAllLoanAdvanceCollectedMembersListFailure(error));
	}
}

export function* resetAllLoanAdvanceCollectedMembersListResponse() {
	yield put(getAllLoanAdvanceCollectedMembersListResponseChanged());
}

export function* onGetAllLoanAdvanceCollectedMembersListStart() {
	yield takeLatest(
		CloseLoanAdvanceTypes.GET_ALL_LOAN_ADVANCE_COLLECTED_MEMBERS_LIST_START,
		getAllLoanAdvanceCollectedMembersListData,
	);
}

export function* onGetAllLoanAdvanceCollectedMembersListResponseReset() {
	yield takeLatest(
		CloseLoanAdvanceTypes.GET_ALL_LOAN_ADVANCE_COLLECTED_MEMBERS_LIST_RESPONSE_RESET_START,
		resetAllLoanAdvanceCollectedMembersListResponse,
	);
}
/***************** GET ALL LOAN ADVANCE COLLECTED MEMBER LIST ****************** */

/***************** GET PARTICULAR ACCOUNT NAME INFO ****************** */
export function* getParticularAccountNameInfoData({ payload }: any) {
	try {
		const { accountName, infogCompanyID, databaseName, companyID } = payload;
		const key = 'GetParticularAccountNameInfoKey';
		const jsonData = {
			DatabaseName: databaseName,
			MemberCompanyID: companyID,
			InfogID: infogCompanyID,
			AccountName: accountName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const response = yield call(fetchParticularAccountName, encodeData);
		if (response.data.statusCode === '100') {
			yield put(fetchParticularAccountNameInfoFailure(response.data));
		} else {
			yield put(fetchParticularAccountNameInfoSuccess(response.data));
		}
	} catch (error) {
		yield put(fetchParticularAccountNameInfoFailure(error));
	}
}

export function* onGetParticularAccountNameInfoStart() {
	yield takeLatest(
		CloseLoanAdvanceTypes.FETCH_PARTICULAR_ACCOUNT_NAME_INFO_START,
		getParticularAccountNameInfoData,
	);
}

export function* resetParticularAccountNameInfoResponse() {
	yield put(fetchParticularAccountNameInfoStartResponseChanged());
}

export function* onGetParticularAccountNameInfoResponseReset() {
	yield takeLatest(
		CloseLoanAdvanceTypes.FETCH_PARTICULAR_ACCOUNT_NAME_INFO_RESPONSE_RESET_START,
		resetParticularAccountNameInfoResponse,
	);
}
/***************** GET PARTICULAR ACCOUNT NAME INFO ****************** */

/***************** GET ACCOUNT BASED ON TYPE ****************** */
export function* getAccountsBasedonTypeData({ payload }: any) {
	try {
		const { areaID, databaseName } = payload;
		const key = 'getAccountsBasedonTypeKey';
		const jsonData = {
			AreaID: areaID,
			DatabaseName: databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const response = yield call(fetchAccountsBasedonType, encodeData);
		if (response.data.statusCode === '100') {
			yield put(getAccountsBasedonTypeFailure(response.data));
		} else {
			yield put(getAccountsBasedonTypeSuccess(response.data));
		}
	} catch (error) {
		yield put(getAccountsBasedonTypeFailure(error));
	}
}

export function* resetAccountsBasedonTypeResponse() {
	yield put(getAccountsBasedonTypeResponseChanged());
}

export function* onGetAccountsBasedonTypeStart() {
	yield takeLatest(
		CloseLoanAdvanceTypes.GET_ACCOUNTS_BASEDON_TYPE_START,
		getAccountsBasedonTypeData,
	);
}

export function* onGetAccountsBasedonTypeResponseReset() {
	yield takeLatest(
		CloseLoanAdvanceTypes.GET_ACCOUNTS_BASEDON_TYPE_RESPONSE_RESET_START,
		resetAccountsBasedonTypeResponse,
	);
}
/***************** GET ACCOUNT BASED ON TYPE ****************** */

/***************** UPDATE CLOSE LOAN ADVANCE WITH REPAYMENT ****************** */
export function* updateCloseLoanAdvanceWithRepaymentData({ payload }: any) {
	try {
		const key = 'updateCloseLoanAdvanceKey';
		const {
			databaseName,
			closeDate,
			branchID,
			infogID,
			closeMemberList,
			userID,
			loanAdvanceAccountID,
			companyID,
		} = payload;
		const jsonData = {
			DatabaseName: databaseName,
			CloseDate: closeDate,
			BranchID: branchID,
			InfogID: infogID,
			CloseMemberList: closeMemberList,
			UserID: userID,
			LoanAdvanceAccountID: loanAdvanceAccountID,
			CompanyID: companyID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const response = yield call(updateCloseLoanAdvanceWithRepayment, encodeData);
		if (response.data.statusCode === '100') {
			yield put(updateCloseLoanAdvanceWithRepaymentFailure(response.data));
		} else {
			yield put(updateCloseLoanAdvanceWithRepaymentSuccess(response.data));
		}
	} catch (error) {
		yield put(updateCloseLoanAdvanceWithRepaymentFailure(error));
	}
}

export function* resetUpdateCloseLoanAdvanceWithRepaymentResponse() {
	yield put(updateCloseLoanAdvanceWithRepaymentResponseChanged());
}

export function* onUpdateCloseLoanAdvanceWithRepaymentStart() {
	yield takeLatest(
		CloseLoanAdvanceTypes.UPDATE_CLOSE_LOAN_ADVANCE_WITH_REPAYMENT_START,
		updateCloseLoanAdvanceWithRepaymentData,
	);
}

export function* onUpdateCloseLoanAdvanceWithRepaymentResponseReset() {
	yield takeLatest(
		CloseLoanAdvanceTypes.UPDATE_CLOSE_LOAN_ADVANCE_WITH_REPAYMENT_RESPONSE_RESET_START,
		resetUpdateCloseLoanAdvanceWithRepaymentResponse,
	);
}
/***************** UPDATE CLOSE LOAN ADVANCE WITH REPAYMENT ****************** */

/***************** REVERT CLOSE LOAN ADVANCE WITH REPAYMENT ****************** */
export function* revertCloseLoanAdvanceWithRepaymentData({ payload }: any) {
	try {
		const key = 'RevertCloseLoanAdvanceKey';
		const {
			myThriftID,
			closeLoanIndexGroupMemberID,
			branchCashAccountID,
			repayLoanAdvanceAmount,
			memberID,
			memberUniqueID,
			memberName,
			closeDate,
			userName,
			userID,
			companyID,
			branchID,
			databaseName,
			infogCompanyID,
			loanAdvanceAccountID,
		} = payload;
		const jsonData = {
			MyThriftID: myThriftID,
			CloseLoanIndexGroupMemberID: closeLoanIndexGroupMemberID,
			BranchCashAccountID: branchCashAccountID,
			RepayLoanAdvanceAmount: repayLoanAdvanceAmount,
			MemberID: memberID,
			MemberUniqueID: memberUniqueID,
			MemberName: memberName,
			CloseDate: closeDate,
			UserName: userName,
			UserID: userID,
			CompanyID: companyID,
			BranchID: branchID,
			DatabaseName: databaseName,
			InfogID: infogCompanyID,
			LoanAdvanceAccountID: loanAdvanceAccountID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const response = yield call(revertCloseLoanAdvanceWithRepayment, encodeData);
		if (response.data.statusCode === '100') {
			yield put(revertCloseLoanAdvanceWithRepaymentFailure(response.data));
		} else {
			yield put(revertCloseLoanAdvanceWithRepaymentSuccess(response.data));
		}
	} catch (error) {
		yield put(revertCloseLoanAdvanceWithRepaymentFailure(error));
	}
}

export function* resetRevertCloseLoanAdvanceWithRepaymentResponse() {
	yield put(revertCloseLoanAdvanceWithRepaymentResponseChanged());
}

export function* onRevertCloseLoanAdvanceWithRepaymentStart() {
	yield takeLatest(
		CloseLoanAdvanceTypes.REVERT_CLOSE_LOAN_ADVANCE_WITH_REPAYMENT_START,
		revertCloseLoanAdvanceWithRepaymentData,
	);
}

export function* onRevertCloseLoanAdvanceWithRepaymentResponseReset() {
	yield takeLatest(
		CloseLoanAdvanceTypes.REVERT_CLOSE_LOAN_ADVANCE_WITH_REPAYMENT_RESPONSE_RESET_START,
		resetRevertCloseLoanAdvanceWithRepaymentResponse,
	);
}
/***************** REVERT CLOSE LOAN ADVANCE WITH REPAYMENT ****************** */

export function* closeLoanAdvanceSaga() {
	yield all([
		call(onGetAllLoanAdvanceCollectedMembersListStart),
		call(onGetAllLoanAdvanceCollectedMembersListResponseReset),
		call(onGetParticularAccountNameInfoStart),
		call(onGetParticularAccountNameInfoResponseReset),
		call(onGetAccountsBasedonTypeStart),
		call(onGetAccountsBasedonTypeResponseReset),
		call(onUpdateCloseLoanAdvanceWithRepaymentStart),
		call(onUpdateCloseLoanAdvanceWithRepaymentResponseReset),
		call(onRevertCloseLoanAdvanceWithRepaymentStart),
		call(onRevertCloseLoanAdvanceWithRepaymentResponseReset),
	]);
}
